<template>
  <Modal v-if="visible" :value="true" @input="closeModal">
    <div slot="header">
      Configurar o tipo da Coluna
    </div>

    <label for="">Escolha do tipo</label>
    <select v-model="currentField.type" class="form-control">
      <option v-for="type in types" :key="type.value" :value="type.value">
        {{ type.label }}
      </option>
    </select>

    <hr>

    <h3>Propiedadade</h3>

    <div class="row">
      <div class="col-md-4">
        <label class="float-right">Nome da Coluna</label>
      </div>
      <div class="col-md-8">
        <input v-model="currentField.name" class="form-control">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <label class="float-right">Descrição</label>
      </div>
      <div class="col-md-8">
        <input v-model="currentField.description" class="form-control">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <label class="float-right">Valor padrão (default)</label>
      </div>
      <div class="col-md-8">
        <template v-if="['text', 'number'].includes(currentField.type)">
          <input v-model="currentField.default" :type="currentField.type" class="form-control">
        </template>
        <template v-else-if="currentField.type === 'select'">
          <select v-model="currentField.default" class="form-control">
            <option :value="option[1]" v-for="(option, index) in currentField.options" :key="index">
              {{ option[0] }}
            </option>
          </select>
        </template>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <BkpsCheckBox v-model="currentField.required" class="float-right mr-2"/>
      </div>
      <div class="col-md-8">
        <label for="">Obrigatório</label>
      </div>
    </div>

    <div v-if="currentField.type === 'select'" class="ibox">
      <div class="ibox-title">
        <span class="mr-4">Opções de seleção</span>
        <button class="btn btn-outline mr-2" @click="addSelect()">
          Adionar Linha
        </button>

        <input accept=".csv, .CSV" type="file" class="btn btn-outline" ref="input" @change="readFile">
      </div>

      <div class="ibox-content">
        <table class="table">
          <thead>
            <tr>
              <th>Rótulo</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(select, index) in currentField.options" :key="index">
              <td><input v-model="select[0]" class="form-control"></td>
              <td><input v-model="select[1]" class="form-control"></td>
              <td>
                <button class="btn btn-sm btn-outline mr-1" @click="cloneSelect(select)">Clonar</button>
                <button class="btn btn-sm btn-outline-red" @click="deleteSelect(index)">X</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr>
    <button class="btn btn-success mr-1" @click="apply()">Aplicar</button>
    <button class="btn btn-outline mr-1" @click="closeModal()">Cancelar</button>

  </Modal>
</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import Modal from '@/components/shares/specialTag/Modal'

  export default {
    components: { BkpsCheckBox, Modal },
    computed: {
      visible() {
        return this.currentField && this.value
      }
    },
    created() {
      this.loadCurrentField()
    },
    data() {
      return {
        currentField: {},
        types: [
          { label: 'Texto', value: 'text' },
          { label: 'Numérico', value: 'number' },
          { label: 'Seleção', value: 'select' },
        ],
      }
    },
    methods: {
      addSelect(value) {
        if (!value)
          value = [`label${this.currentField.options.length}`, `value${this.currentField.options.length}`]

        this.currentField.options.push(value)
      },
      apply() {
        Object.assign(this.field, this.currentField)
        this.$emit('setField')
        this.closeModal()
      },
      cloneSelect(select) {
        this.addSelect([...select])
      },
      closeModal() {
        this.currentField = {}
        this.$emit('input', false)
      },
      deleteSelect(index) {
        this.currentField.options.splice(index, 1)
      },
      loadCurrentField() {
        this.currentField = {...this.field}

        if (!('type' in this.currentField))
          this.$set(this.currentField, 'type', 'text')

        if (!('options' in this.currentField))
          this.$set(this.currentField, 'options', [])
      },
      readFile() {
        const file = this.$refs.input.files[0]
        const reader = new FileReader()
        reader.onloadend = (e) =>  {
          this.currentField.options = e.target.result.split('\n').map(line => {
            const [first, last] = line.split(';')
            return [first.trim(), last.trim()]
          })
        }
        reader.readAsText(file, 'UTF-8')
      }
    },
    name: 'Field',
    props: {
      field: { required: true, type: Object },
      value: { default: false, type: Boolean }
    },
    watch: {
      visible(newValue) {
        if (newValue)
          this.loadCurrentField()
      }
    }
  }
</script>

<style scoped>

  .table td {
    padding: 8px;
  }

</style>